export class RemoveEmptyRows {
  constructor(el) {
    this.table = document.querySelector(el);
    if (!this.table) {
      return;
    }
    this.init();
  }
  init() {
    let rows = this.table.querySelectorAll("tbody > tr");
    rows.forEach((row) => {
      let cells = row.querySelectorAll("td:last-child");
      cells.forEach((cell) => {
        if (cell.textContent.trim() === "-") {
          let parent = cell.parentElement;
          parent.style.display = "none";
          return;
        }
      });
    });
  }
}
